const initState = {
    disputeInfo: {},
    disputeReasons: [],
    invoiceHeader: {},
    invoiceDetails: [],
    disputeContact: {
        hospitalName: '',
        accountNumber: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
    },
    selectedReason: null,
    selectedDisputeSubReason: null,
    disputeComment: '',
    summaryComment: '',
    disputeAttachment: {},
    disputeRaised: false,
};
const intialFormState = {
    disputeInfo: {},
    disputeContact: {
        hospitalName: '',
        accountNumber: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
    },
    selectedReason: null,
    selectedDisputeSubReason: null,
    disputeComment: '',
    summaryComment: '',
    disputeAttachment: {},
};

const SET_DISPUTE = 'SET_DISPUTE';
const SET_DISPUTE_REASONS = 'SET_DISPUTE_REASONS';
const SET_DISPUTE_CONTACT = 'SET_DISPUTE_CONTACT';
const SET_ACC_INVOICE_HEADER = 'SET_ACC_INVOICE_HEADER';
const SET_ACC_INVOICE_DETAILS = 'SET_ACC_INVOICE_DETAILS';
const SET_SELECTED_REASON = 'SET_SELECTED_REASON';
const SET_SELECTED_DISPUTE_SUBREASON = 'SET_SELECTED_DISPUTE_SUBREASON';
const SET_DISPUTE_COMMENT = 'SET_DISPUTE_COMMENT';
const SET_SUMMARY_COMMENT = 'SET_SUMMARY_COMMENT';
const SET_DISPUTE_ATTACHMENT = 'SET_DISPUTE_ATTACHMENT';
const RESET_STATE = 'RESET_STATE';
const DISPUTE_RAISED = 'DISPUTE_RAISED';
const RESET_DATA_STATE = 'RESET_DATA_STATE';

export const setDispute = (data) => ({ type: SET_DISPUTE, payload: data });
export const setDisputeReasons = (data) => ({ type: SET_DISPUTE_REASONS, payload: data });
export const setDisputeContact = (data) => ({ type: SET_DISPUTE_CONTACT, payload: data });
export const setAccountInvoiceHeader = (data) => ({ type: SET_ACC_INVOICE_HEADER, payload: data });
export const setAccountInvoiceDetails = (data) => ({
    type: SET_ACC_INVOICE_DETAILS,
    payload: data,
});
export const setSelectedReason = (data) => ({ type: SET_SELECTED_REASON, payload: data });
export const setSelectedDisputeSubReason = (data) => ({
    type: SET_SELECTED_DISPUTE_SUBREASON,
    payload: data,
});
export const setDisputeComment = (data) => ({ type: SET_DISPUTE_COMMENT, payload: data });
export const setSummaryComment = (data) => ({ type: SET_SUMMARY_COMMENT, payload: data });
export const setDisputeAttachment = (data) => ({ type: SET_DISPUTE_ATTACHMENT, payload: data });
export const resetRaiseDispute = () => ({ type: RESET_STATE, payload: initState });
export const resetRaiseDisputeData = () => ({ type: RESET_DATA_STATE, payload: intialFormState });
export const setDisputeRaised = (data) => ({ type: DISPUTE_RAISED, payload: data });

export default (state = initState, action) => {
    switch (action.type) {
        case SET_DISPUTE:
            return { ...state, disputeInfo: action.payload };
        case SET_DISPUTE_REASONS:
            return { ...state, disputeReasons: action.payload };
        case SET_DISPUTE_CONTACT:
            return { ...state, disputeContact: action.payload };
        case SET_ACC_INVOICE_HEADER:
            return { ...state, invoiceHeader: action.payload };
        case SET_ACC_INVOICE_DETAILS:
            return { ...state, invoiceDetails: action.payload };
        case SET_SELECTED_REASON:
            return { ...state, selectedReason: action.payload };
        case SET_SELECTED_DISPUTE_SUBREASON:
            return { ...state, selectedDisputeSubReason: action.payload };
        case SET_DISPUTE_COMMENT:
            return { ...state, disputeComment: action.payload };
        case SET_SUMMARY_COMMENT:
            return { ...state, summaryComment: action.payload };
        case SET_DISPUTE_ATTACHMENT:
            return { ...state, disputeAttachment: action.payload };
        case RESET_STATE:
            return { ...state, ...action.payload };
        case RESET_DATA_STATE:
            return { ...state, ...action.payload };
        case DISPUTE_RAISED:
            return { ...state, disputeRaised: action.payload };
        default:
            return state;
    }
};
